"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
exports.defer = rxjs_1.defer;
//# sourceMappingURL=defer.js.map